import { IIndividual } from "../../../types/individual";
import { IOrg } from "../../../types/org";
import { IPosition } from "../../../types/position";
import CollapsablePanel from "../../common/collapsable-panel/collapsable-panel";
import Info from "../../common/info";
import IndividualAssignments from "./individual-assignments/individual-assignments";
import IndividualInformation from "./individual-information/individual-information";

type IndividualDetailsProp = {
  individual: IIndividual;
  org: IOrg | undefined;
  position: IPosition | undefined;
  onNameUpdate: (fullName:string)=>void;
  orgReadOnly:boolean;
}

const IndividualDetails: React.FC<IndividualDetailsProp> = ({ individual, org, position,onNameUpdate,orgReadOnly }) => {

  return (
    <>
      <Info>If you need to change details of an Individual's name, please contact the ministry coordinator.</Info>
      {individual &&
        <>
          <CollapsablePanel headTitle="Individual Information" initCollapse={false} helpUrl="">
            <IndividualInformation org={org} position={position} individual={individual} onNameUpdate={onNameUpdate} orgReadOnly={orgReadOnly}/>
          </CollapsablePanel>

          <CollapsablePanel headTitle="Assignments" initCollapse={false} helpUrl="">
            <IndividualAssignments individual={individual}/>
          </CollapsablePanel>
        </>
      }
    </>)
}

export default IndividualDetails;
